import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'minuteSeconds' })
export class MinuteSecondsPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    const minutes = Math.floor(value / 60) || 0;
    const seconds = value - minutes * 60 || 0;

    return minutes + ':' + (Math.trunc(seconds) < 10 ? '0' : '') + Math.trunc(seconds);
  }
}
